import { concatMap, tap, map } from 'rxjs/operators';
import { HttpServiceBase, RxUtils, TypeUtils } from '@utils';
import { httpService } from '@services/http';
import { logger } from '@services/logger';
import { FleetVehicle } from '@services/fleet-vehicle';
import { CreateEasyInputDto } from './create-easy-input.dto';

export class EasyInputService extends HttpServiceBase {
	constructor() {
		super('easy-input');
	}

	create(dto: CreateEasyInputDto[]) {
		return httpService.post<FleetVehicle[]>(this.getUrl(), ``, { body: dto, errorHandler: 'notification' }).pipe(
			tap((result) => logger.debug(`[${this.constructor.name}.${this.create.name}]`, result)),
			concatMap((result) => RxUtils.valueOrThrow(result, new Error('Response is empty'))),
			map((result) => TypeUtils.convert(FleetVehicle, result))
		);
	}

	checkApplicable() {
		return httpService.get<boolean>(this.getUrl(), `applicable`).pipe(
			tap((result) => logger.debug(`[${this.constructor.name}.${this.checkApplicable.name}]`, result)),
			map((result) => result === true)
		);
	}
}

export const easyInputService = new EasyInputService();
